import { useEffect } from "react";
import Job from "./Job";
import Wrapper from "../assets/wrappers/JobsContainer";
import { useSelector, useDispatch } from "react-redux";
import Loading from "./Loading";
import { getAllJobs } from "../features/alljobs/allJobsSlice";
import PageBtnContainer from "./PageBtnContainer";

function JobsContainer() {

    const {isLoading,search, searchStatus,searchType,sort, jobs, page, totalJobs, numOfPages} = useSelector((store)=>  store.allJobs);
    const dispatch = useDispatch();

    useEffect( () => {
        dispatch(getAllJobs());
    }, [page, search,searchStatus,searchType,sort] )
     
     if(isLoading){
        return (
            <Loading />
        );
     }

     if(jobs.length === 0){
        return (
            <Wrapper>
                <h2>No jobs to display...</h2>
            </Wrapper>
        )
     }

     return (
        <Wrapper>
            <h5>Jobs Found {totalJobs}</h5>
            <div className="jobs">
                {
                    jobs.map( (job) => {
                        return <Job key={job._id} {...job}/>
                    })
                }
            </div>
            {numOfPages > 1 && <PageBtnContainer />}
        </Wrapper>
     )
}

export default JobsContainer